import { useState, useEffect } from 'react'
import './Interactive.css'

const noop = () => {}

const Interactive = ({
  cat,
  itemName,
  alt,
  url,
  sound = 'bloop',
  onClick = noop,
  onHover = noop,
}) => {
  const [hovering, setHovering] = useState(false)

  useEffect(() => {
    if (hovering) {
      const audio = document.getElementById(sound)
      audio.play().catch((e) => {
        console.log(e)
      })
    }
  }, [hovering, sound])

  // const getContentSrc = (path) => {
  //   const prefix =
  //     process.env.NODE_ENV === 'development'
  //       ? ''
  //       : 'wp-content/uploads/horsepower-files/'
  //   return `${prefix}${path}`
  // }

  const cName = 'interactiveImageArea ' + itemName + 'Box'

  // const imgSrc = getContentSrc('images/' + cat + '/' + itemName + '.png')

  const imgSrc = 'images/' + cat + '/' + itemName + '.png'

  // console.log('imgSrc', imgSrc, process.env.NODE_ENV)

  const imgCName = 'interactiveImage ' + itemName

  const doHover = (hovering) => {
    setHovering(hovering)
  }

  const doClick = (nelsonSpeaks) => {
    onClick(nelsonSpeaks)
  }

  return (
    <div className={cName}>
      <img
        className={imgCName}
        src={imgSrc}
        alt={alt}
        onMouseEnter={() => doHover(true)}
        onMouseLeave={() => doHover(false)}
        onClick={() => doClick(true)}
      />
    </div>
  )
}

export default Interactive
